import { render, staticRenderFns } from "./NewSmsPage.vue?vue&type=template&id=090a8ad4&scoped=true&"
import script from "./NewSmsPage.vue?vue&type=script&lang=ts&"
export * from "./NewSmsPage.vue?vue&type=script&lang=ts&"
import style0 from "./NewSmsPage.vue?vue&type=style&index=0&id=090a8ad4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090a8ad4",
  null
  
)

export default component.exports